import { Circle } from "@chakra-ui/react"

const CircleDivider = () => <Circle size={1} mx={1.5} bgColor="gray.400" />

export default CircleDivider
